import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Text, VStack } from '@chakra-ui/react';
import { ADVISOR_TEAM_UPGRADE_PRODUCT_ID } from '@src/components/sco/Advisors/model/access';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { ConversionGate } from '@src/components/sco/Conversion/controller/ConversionGate';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type TeamAdvisorPaywallProps = {
  advisorName?: string | null;
  /** Compact empty-state vs full message gate. */
  variant?: 'empty' | 'gate';
};

/**
 * Paywall for human Startups.com team advisors (Advisor Team, `canAccessAdvisorTeam`). Free and
 * Startups Pro members see it; the Conversion gate names Advisor Team at its catalog price and
 * opens the checkout for that same plan.
 */
export const TeamAdvisorPaywall = t0 => {
  const $ = _c(22);
  const {
    advisorName,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "gate" : t1;
  const paths = useAdvisorsPaths();
  let t2;
  if ($[0] !== advisorName) {
    t2 = advisorName?.trim();
    $[0] = advisorName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const execName = t2;
  let t3;
  if ($[2] !== execName) {
    t3 = execName ? {
      execName
    } : undefined;
    $[2] = execName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = {
      intent: "leadership-message" as const,
      permission: "canAccessAdvisorTeam" as const,
      productId: ADVISOR_TEAM_UPGRADE_PRODUCT_ID,
      tokens: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const gateArgs = t4;
  if (variant === "empty") {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Text color="colorPalette.fg/60" maxWidth="md" textAlign="center">Message the Startups.com executive team on demand — office hours, workshops, and real answers when AI is not enough.</Text>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        width: "auto"
      };
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== gateArgs) {
      t7 = <ConversionGate {...gateArgs} compactCta={true} ctaLabel="Upgrade to Access Advisor Team" ctaProps={t6} density="button" />;
      $[8] = gateArgs;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    const t8 = `${paths.base}/upgrade`;
    let t9;
    if ($[10] !== t8) {
      t9 = <Button asChild={true} size="sm" variant="ghost"><NextLink href={t8}>See what's included</NextLink></Button>;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    let t10;
    if ($[12] !== t7 || $[13] !== t9) {
      t10 = <VStack align="center" flex={1} gap={4} justify="center" padding={6}>{t5}{t7}{t9}</VStack>;
      $[12] = t7;
      $[13] = t9;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    return t10;
  }
  let t5;
  if ($[15] !== gateArgs) {
    t5 = <ConversionGate {...gateArgs} assurance="Cancel anytime" density="boxed" />;
    $[15] = gateArgs;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = `${paths.base}/upgrade`;
  let t7;
  if ($[17] !== t6) {
    t7 = <Button asChild={true} alignSelf="center" size="sm" variant="ghost"><NextLink href={t6}>View full upgrade details</NextLink></Button>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <Stack gap={2} maxWidth="md" width="full">{t5}{t7}</Stack>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};